import getEditorialPhotos from "./getEditorialPhotos";
import getSearchPhotos from "./getSearchPhotos";

export default () => ({
  getEditorialPhotos: getEditorialPhotos(),
  getSearchPhotos: getSearchPhotos(),
})